export const genId = () => `el_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;

export const genMatchId = () => `mi_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;

export const defaultElement = (type) => {
	const shapeType = type.startsWith("shape-") ? type.replace("shape-", "") : null;
	const isLine = type === "shape-line";
	const base = {
		elementId: genId(),
		type: shapeType ? "shape" : type,
		x: 50,
		y: 50,
		width: shapeType ? (isLine ? 150 : 100) : 200,
		height: shapeType ? (isLine ? 8 : 100) : 80,
		entryAnimation: "none",
		entryAnimationDuration: 500,
	};
	if (type === "text")
		return {
			...base,
			content: { html: "<p>Nuevo texto</p>" },
			style: {
				fontFamily: "Arial, sans-serif",
				fontSize: 18,
				color: "#000000",
				backgroundColor: "transparent",
				fontWeight: "normal",
				fontStyle: "normal",
				textDecoration: "none",
				textAlign: "left",
				letterSpacing: 0,
				lineHeight: 1.3,
			},
		};
	if (type === "image")
		return { ...base, content: { url: "", alt: "" } };
	if (type === "video")
		return { ...base, content: { url: "" }, width: 400, height: 225 };
	if (type === "audio")
		return {
			...base,
			width: 200,
			height: 72,
			content: {
				url: "",
				autoplay: true,
				loop: true,
				volume: 0.7,
				hiddenInPlay: true,
			},
		};
	if (type === "quiz")
		return {
			...base,
			width: 540,
			height: 400,
			content: {
				quizId: null,
				quizBackgroundRgba: "rgba(255,255,255,0)",
				quizBorderWidth: 0,
				quizBorderRgba: "rgba(0,0,0,1)",
				quizBlockShadowBlur: 8,
				quizQuestionTextAlign: "center",
				quizOptionsStyle: {
					fontFamily: "'Bebas Neue', sans-serif",
					fontSize: 20,
					textAlign: "center",
					color: "#334155",
				},
				quizOptionsCustom: {
					optionBorderColor: "#334155",
					optionBorderWidth: 3,
					optionBorderRadius: 10,
					optionBgHover: "rgba(196,227,234,1)",
				},
			},
			style: {
				backgroundColor: "rgba(255,255,255,0)",
			},
		};
	if (type === "button")
		return {
			...base,
			width: 160,
			height: 44,
			content: { action: "nextPage", label: "Siguiente", icon: "", iconPosition: "before", showWhen: "always", showAfterSeconds: 0, hideAfterSeconds: 0, onlyOnce: false },
			style: {
				fontFamily: "Arial, sans-serif",
				fontSize: 16,
				fontWeight: "bold",
				color: "rgba(51, 51, 51, 1)",
				backgroundColor: "transparent",
				textAlign: "center",
				borderRadius: 8,
			},
		};
	if (type === "hint")
		return {
			...base,
			width: 120,
			height: 40,
			content: { label: "Pista", hintText: "", hintPenalty: 0 },
			style: {
				fontFamily: "Arial, sans-serif",
				fontSize: 14,
				fontWeight: "bold",
				color: "rgba(124, 58, 237, 1)",
				backgroundColor: "rgba(245, 243, 255, 1)",
				borderColor: "rgba(124, 58, 237, 1)",
				borderWidth: 1,
				textAlign: "center",
				borderRadius: 8,
			},
		};
	if (shapeType) {
		return {
			...base,
			content: {
				shapeType,
				fillColor: "rgba(0, 0, 0, 1)",
				strokeColor: "rgba(0, 0, 0, 1)",
				strokeWidth: 0,
				borderRadius: 0,
			},
		};
	}
	return base;
};
